import { Building2, Bed, Stethoscope, Sparkles, Dumbbell, Scissors, ArrowRight, CheckCircle2 } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_7a187c08-1566-4a5d-94a6-902036d37fa8/artifacts/oin9oc2t_Untitled%20design%20%2814%29.png";
const COMMERCIAL_IMG = "https://customer-assets.emergentagent.com/job_poly-laundry-pro/artifacts/g16y2r3t_IMG_9675.png";

const industries = [
  { icon: Bed, label: 'VRBO / Airbnb / Resorts' },
  { icon: Stethoscope, label: 'Medical Clinics & Surgery Centers' },
  { icon: Sparkles, label: 'Massage & Spa' },
  { icon: Dumbbell, label: 'Physical Therapy Clinics' },
  { icon: Scissors, label: 'Barber & Beauty Shops' },
  { icon: Building2, label: 'Hospitality & Service Businesses' },
];

const benefits = [
  'Recurring scheduled service',
  'Reliable fast turnaround',
  'Contact us for custom pricing',
  'Customized service plans',
  'No contract required',
  'Flexible billing options',
  'Free pickup & delivery',
  'Same-day / next-day available',
];

export default function CommercialSection() {
  const scrollTo = (e, id) => {
    e.preventDefault();
    const el = document.querySelector(id);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section id="commercial" className="py-24 md:py-32 bg-white" data-testid="commercial-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left: Image */}
          <div className="reveal">
            <div className="relative rounded-3xl overflow-hidden">
              <img
                src={COMMERCIAL_IMG}
                alt="Commercial laundry facility with industrial washers"
                className="w-full h-[400px] lg:h-[500px] object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-poly-blue-dark/80 to-transparent p-8">
                <p className="text-white font-heading font-bold text-2xl">Trusted by Local Businesses</p>
                <p className="text-white/80 text-sm mt-1">Serving Mountain Home's commercial community since 1963</p>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div className="reveal reveal-delay-2">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-white rounded-full p-1 shadow-md ring-1 ring-slate-100">
                <img src={LOGO_URL} alt="Poly Clean Center" className="w-8 h-8 object-contain" />
              </div>
              <span className="text-poly-orange font-semibold text-sm tracking-wider uppercase">Commercial Laundry</span>
            </div>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl text-poly-blue-dark tracking-tight mb-4">
              Professional Laundry Service{' '}
              <span className="text-poly-blue">for Your Business</span>
            </h2>
            <p className="text-poly-muted text-base leading-relaxed mb-6">
              Let us handle your laundry needs so you can focus on running your business. 
              We provide affordable, dependable commercial laundry service with customized 
              plans, flexible billing, and no contracts.
            </p>

            {/* Industries */}
            <div className="grid grid-cols-2 gap-3 mb-8">
              {industries.map((item, i) => (
                <div
                  key={i}
                  className="industry-card flex items-center gap-3 p-3 rounded-xl border border-slate-100 bg-poly-bg"
                  data-testid={`industry-${i}`}
                >
                  <item.icon className="w-5 h-5 text-poly-blue shrink-0" />
                  <span className="text-sm font-medium text-poly-blue-dark">{item.label}</span>
                </div>
              ))}
            </div>

            {/* Benefits */}
            <div className="grid grid-cols-2 gap-2 mb-8">
              {benefits.map((b, i) => (
                b === 'Contact us for custom pricing' ? (
                  <a
                    key={i}
                    href="#contact"
                    onClick={(e) => scrollTo(e, '#contact')}
                    className="flex items-center gap-2 text-sm text-poly-orange font-semibold hover:text-orange-600 transition-colors"
                  >
                    <CheckCircle2 className="w-4 h-4 text-poly-orange shrink-0" />
                    Contact Us for Pricing &rarr;
                  </a>
                ) : (
                  <div key={i} className="flex items-center gap-2 text-sm text-poly-muted">
                    <CheckCircle2 className="w-4 h-4 text-poly-green shrink-0" />
                    {b}
                  </div>
                )
              ))}
            </div>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#contact"
                onClick={(e) => scrollTo(e, '#contact')}
                className="inline-flex items-center justify-center gap-2 bg-poly-blue hover:bg-blue-900 text-white font-semibold px-6 py-3.5 rounded-full transition-all"
                data-testid="commercial-quote-btn"
              >
                Request a Commercial Quote
                <ArrowRight className="w-4 h-4" />
              </a>
              <a
                href="tel:8704254295"
                className="inline-flex items-center justify-center gap-2 border-2 border-poly-blue text-poly-blue font-semibold px-6 py-3.5 rounded-full hover:bg-poly-blue hover:text-white transition-all"
                data-testid="commercial-call-btn"
              >
                Call to Discuss
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
